import { fromJS, List } from 'immutable';
import { omitBy, isUndefined, isEqual } from 'lodash';

import * as actions from './actions';
import { SelectModes } from '../../components/FilterableTable/constants';

const initialState = fromJS({
  options: {
    filters: {},
  },
  selectedIds: [],
  selectMode: SelectModes.WHITELIST,
});

const normalizePoints = (filtersObj) => {
  const result = { ...filtersObj };

  if (!result.points || !result.points.length) {
    result.points = [];
  } else if (List.isList(result.points)) {
    result.points = result.points.toJS();
  }
  return result;
};

const filters = state => normalizePoints(state.getIn(['options', 'filters']).toJS());

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_VIEW_OPTIONS.INTENT: {
      const { _pageChangeOnly, ...viewOptions } = action.payload;
      const payloadFilters = viewOptions.filters
        ? normalizePoints(viewOptions.filters.geoCodes ? {
          ...viewOptions.filters,
          geoCodes: viewOptions.filters.geoCodes.toJS(),
        } : viewOptions.filters)
        : viewOptions.filters;

      if (!_pageChangeOnly && !isEqual(filters(state), payloadFilters)) {
        return state.merge({
          options: viewOptions,
          selectedIds: [],
          selectMode: SelectModes.WHITELIST,
        });
      }

      return state.merge({ options: viewOptions });
    }

    case actions.SET_SELECTED.INTENT: {
      return state.merge(
        omitBy(
          {
            selectedIds: action.payload.ids,
            selectMode: action.payload.mode,
          },
          value => isUndefined(value),
        ),
      );
    }

    default:
      return state;
  }
}
